/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { WhatsAppPhoneListResponse } from '../models/WhatsAppPhoneListResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MessagingWhatsappPhonesService {
    /**
     * @param tenantId
     * @returns WhatsAppPhoneListResponse Ok
     * @throws ApiError
     */
    public static getPhones(
        tenantId?: string,
    ): CancelablePromise<WhatsAppPhoneListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/messaging/whatsapp/phones',
            query: {
                'tenantId': tenantId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden.`,
            },
        });
    }
}
